<template>
  <commonbody>
    <div class="row mx-0 wine-details-header-box" slot="swiper">
      <div class="wine-details-content-header">

      </div>
      <div class="row my-5 wine-details-content common-width-box" :style="getCommonStyle.style">
        <div class="col-5 col-lg-5 col-md-12 wine-details-content-img border-0 px-4 py-0 py-md-5 py-lg-0">
          <img v-if="detailsData.picture_url" :src="'/express_api/' + detailsData.picture_url" alt="Estate Select"
            id="product-main-image">
        </div>
        <div class="col-7 col-lg-7 col-md-12 border-0 px-4 py-1 wine-details-content-box">
          <h2>
            <span>{{ detailsData.name }} </span><br>
            {{ detailsData.english_name }}
          </h2>
          <ul class="specs">
            <li><p>品种：</p>{{ detailsData.breed }}</li>
            <li class="abv"><p>酒精度：</p>{{ detailsData.purity }} vol</li>
            <li class="size"><p>适饮温度：</p>{{ detailsData.drinking }}</li>
            <li class="type"><p>种植：</p>{{ detailsData.plant }}</li>
          </ul>
          <div :class="{ 'wine-details-intro': true, 'wine-details-intro-more': !isMore }">
            <p v-html="detailsData.intro"></p>
            <p v-html="detailsData.english_intro"></p>
          </div>
          <div class="wine-details-more" @click="isMore = !isMore">
            {{ isMore ? "更多" : "收起" }}
          </div>
          <!-- <div class="purchase">
            ¥{{ detailsData.price }}
          </div> -->
          <div class="common-btn" style="float: left;margin-top: 10px;font-family: serif;">buy now</div>
        </div>
      </div>
    </div>
    <div class="row mx-0 wine-details-swiper common-margin" v-if="carouselData.fileList.length">
      <div class="wine-details-swiper-box common-width-box">
        <swiper ref="mySwiper2" :options="swiperOptions2">
          <swiper-slide v-for="(item, key) in carouselData.fileList" :key="key">
            <div class="wine-details-swiper-img-box">
              <img :src="'/express_api' + item.url" />
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <div class="clearfix" id="wine-details-box" :style="getCommonStyle.style">
      <div class="wine-details-box">
        <div class="wine-details-html-content" v-html="detailsData.context"></div>
        <div class="common-btn wine-details-more-btn" @click="$router.push({
                path: '/wineryDetails',
                query: {
                    id: detailsData.cases_id
                }
            })">
          酒庄更多详情
        </div>
      </div>
    </div>
  </commonbody>
</template>

<script>
// @ is an alias to /src
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import commonbody from '@/components/commonbody.vue';
import * as caseApi from '@/api/cases';
import "swiper/css/swiper.min.css";
import { mapGetters } from 'vuex';

export default {
  name: "WineDetails",
  components: {
    commonbody,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      //文章id
      id: "",
      detailsData: {},
      isMore: true,
      carouselData: {
        fileList: [],
      }
    };
  },
  created() {
    this.paramsUrl();
  },
  computed: {
    ...mapGetters(['getCommonStyle']),

    swiper2() {
      return this.$refs?.mySwiper2?.$swiper;
    },

    //轮播配置项
    swiperOptions2() {
      return {
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false // 手动切换之后继续自动轮播
        },
        loop: this.carouselData.fileList.length != 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
      }
    },
  },
  methods: {
    /**
     * @desc 检测页面参数是否完整
     */
    paramsUrl() {
      let query = this.$route.query;

      if (typeof query.id !== 'undefined') {
        this.id = query.id;

        this.selectCaseDetailsById();
        this.selectWineImage();
      } else {
        this.$message({
          message: 'id不存在',
          type: 'warning'
        })
        this.$router.push({
          path: "/wine"
        })
      }
    },
    /**
     * @desc 通过id获取详细数据
     */
    selectCaseDetailsById() {
      let params = {
        id: this.id
      }
      caseApi.selectCaseDetailsById(params).then(res => {
        this.detailsData = res.data[0];
      })
    },
    selectWineImage() {
      caseApi.selectWineImage({ cases_details_id: this.id }).then(response => {
        this.carouselData = {
          fileList: response.data || [],
        }
      })
    },
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.wine-details-header-box {
  background-color: #f4f4f4;
  // margin-top: 80px;
  text-align: left;

  .wine-details-content-header {
    height: 400px;
    background: url('../../public/images/bg.png') no-repeat;
    background-size: cover;
    width: 100%;
  }

  .wine-details-content-img {
    text-align: center;
  }

  .wine-details-content {
    display: flex;
    align-items: center;
    width: 80%;
    max-width: 1500px;
    margin: 0 auto;

    img {
      max-width: 70%;
      margin: 0 auto;
      text-align: right;
    }

    .wine-details-content-box {
      h2 {
        color: #470125;
        padding-bottom: 20px;
        // line-height: 40px;
        font-size: 2.1em;
        font-family: serif;
      }

      ul.specs {
        list-style: none;
        padding: 0;
        margin: 0;
        padding-bottom: 20px;
        text-align: left;
         li{
          p{
            display: inline-block;
            width: 70px;
          }
         }
      }

      .purchase {
        font-size: 3em;
        font-family: serif;
        padding-top: 20px;
      }

      .wine-details-intro {
        // max-height: 70px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 3;
        text-align: justify;
        transition: all 0.5s;
      }

      .wine-details-intro-more {
        display: block;
        text-align: justify;
      }

      .wine-details-more {
        cursor: pointer;
        text-align: right;
      }
    }
  }
}

#wine-details-box {
  margin-top: 20px;

  .wine-details-box {
    width: 50%;
    margin: 0 auto;
    max-width: 1536px;
    margin: 0 auto;
    padding: 20px;
    text-align: left;

    .wine-details-html-content {
      // min-height: 400px;
      padding-bottom: 30px;
      // border-top: 1px solid #BFBFBF;
      overflow: hidden;
    }
  }

  .wine-details-more-btn{
    width: 300px;
    margin: 0 auto;
    background: #470125;
    border-color: #470125;
    line-height: 40px;
    color: #fff;
    margin-bottom: 50px;
    transition: all 0.4s;
    border-radius: 10px;
    p{
      // font-size: 12px;
      margin-top: -18px;
    }

    &:hover {
      opacity: 0.9;
    }
  }
}

.wine-details-swiper {
  width: 100%;
  margin: 0 auto;
  background: #fff;

  //轮播样式
  .wine-details-swiper-box {
    width: 80%;
    max-width: 1536px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;

    .swiper-button-next,
    .swiper-button-prev {
      // border: 1px solid #cccccc;
      padding: 10px;
      color: #EDF0FB;
      width: 100px;
      height: 100px;
      // top: calc(50% - 50px);

      &:hover {
        color: #DA4747;
      }
    }

    .wine-details-swiper-img-box {

      img {
        width: 100%;
        // max-height: 750px;
        max-height: 90vh;
      }
    }
  }
}

.common-mobile-box{
  .wine-details-more-btn{
    width: 80% !important;
    line-height: 80px !important;
  }
}
</style>

<style lang="scss">
#wine-details-box {
  .wine-details-html-content {
    img {
      max-width: 100%;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>